var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3607 1.6875H10.4245C10.2933 1.6875 10.1687 1.74777 10.0884 1.85089L4.56651 8.84598L1.91874 5.49107C1.87869 5.44022 1.82764 5.3991 1.76941 5.3708C1.71119 5.3425 1.64732 5.32776 1.58258 5.32768H0.646422C0.55669 5.32768 0.507136 5.4308 0.562047 5.50045L4.23035 10.1478C4.40178 10.3647 4.73124 10.3647 4.90401 10.1478L11.4451 1.85893C11.5 1.79063 11.4504 1.6875 11.3607 1.6875Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.9734e8555d49c3a2783474328dc3e8c0.svg";
export { ForwardRef as ReactComponent };